import { createSlice } from "@reduxjs/toolkit"

export const accessManagerSlice = createSlice({
    name: "accessManager",
    initialState: {
        accessManagerList: [],
        countryList: [],
        exportList: [],
        accessManagerDetail: {},
        accessLevelList:[],
        isFreshData: false,
        totalEntry: 0,
        filterTerm: ''
    },   
    reducers: {
        setAccessManagerList: (state, action) => {
            state.accessManagerList = action.payload
        },
        setCountryList: (state, action) => {
            state.countryList = action.payload
        },
        setFreshList: (state, action) => {
            state.isFreshData = action.payload
        },
        setExportList: (state, action) => {
            state.exportList = action.payload
        },
        setFilterTerm: (state, action) => {
            state.filterTerm = action.payload
        },
        setTotalEntry: (state, action) => {
            state.totalEntry = action.payload
        },
        setSingleData: (state, action) => {
            state.accessManagerDetail = action.payload
        },
        setAccessLevelList: (state, action) => {
            state.accessLevelList = action.payload
        }
    }
})

export const {
    setAccessManagerList,
    setFreshList,
    setCountryList,
    setExportList,
    setFilterTerm,
    setSingleData,
    setTotalEntry,
    setFilteredList,
    setAccessLevelList
} = accessManagerSlice.actions

export const selectAccessManagerList = (state) => state.accessManager.accessManagerList
export const selectFreshData = (state) => state.accessManager.isFreshData
export const selectCountryList = (state) => state.accessManager.countryList
export const selectExportList = (state) => state.accessManager.exportList
export const selectFilterTerm = (state) => state.accessManager.filterTerm
export const selectTotalEntry = (state) => state.accessManager.totalEntry
export const selectAccessManagerDetail = (state) => state.accessManager.accessManagerDetail
export const selectAccessLevelList = (state) => state.accessManager.accessLevelList

export default accessManagerSlice.reducer
